<template>
  <div class="form-group" :class="{ 'has-error' : model.$error }" >
    <label v-if="showLabel" class="control-label col-sm-4">* Departments:</label>
    <div :class="{ 'col-sm-8': showLabel }">
      <selectize
        class="single selectize selectize-multiple selectize-bordered selectized"
        :class="model.$error ? 'has-error red-border' : ''"
        name="departments"
        v-model="model.$model"
        multiple
        :options="departmentOptions"
        :fetch-results="getDepartments"
        :fetch-more-results="getNextDepartments"/>

      <div v-if="model.$error" class="help-block pull-right">Department is required</div>
    </div>
  </div>
</template>
<script>
import Selectize from '../ext/codium/CodiumSelectize'
import { http } from 'utils'
import { concat, map } from 'lodash'

export default {
  props: {
    model: {
      required: true
    },
    default: {
      required: false,
      default: null
    },
    showLabel: {
      required: false,
      default: true
    }
  },

  data () {
    return {
      departmentOptions: [],
      pagination: {}
    }
  },

  components: {
    Selectize
  },

  created () {
    this.getDepartments()
  },

  methods: {
    getDepartments (search) {
      return http.get(`departments`, { params: { search } })
        .then((response) => {
          this.departmentOptions = map(response.data.data, item => ({ id: item.id, text: item.name }))
        })
    },

    getNextDepartments (search) {
      const params = {
        search,
        page: this.pagination.current_page + 1
      }
      return http.get(`departments`, { params })
        .then((response) => {
          this.departmentOptions = concat(this.departmentOptions, response.data.data)
          this.pagination = response.data.meta
        })
    }
  }
}
</script>
